import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import ContainerButton from "@kikoff/components/src/v1/buttons/ContainerButton";
import Switch from "@kikoff/components/src/v1/inputs/Switch";
import useId from "@kikoff/hooks/src/useId";
import { web } from "@kikoff/proto/src/protos";
import { format } from "@kikoff/utils/src/string";

import { InfoTooltip } from "@component/tooltips/tooltips";
import { updateBag } from "@feature/shopping";
import { getCreditAccountMentalModelName } from "@src/constants";
import { track } from "@util/analytics";

import styles from "./review_autorenew_section.module.scss";

function titleWithoutTimePeriod(title) {
  return title.split(" (")[0];
}

const ReviewAutorenewSection = function ({ product }) {
  const dispatch = useDispatch();

  const checkoutPreview = useSelector((state) => {
    return state.shopping.checkoutPreview;
  });

  if (!checkoutPreview?.autoRenew) return null;

  const productTitle = titleWithoutTimePeriod(product.title);

  const formattedAutorenewDate = format.date(
    checkoutPreview.autoRenew.renewalAt.seconds * 1000,
    "m/dd/yyyy"
  );

  const [autorenewEnabled, setAutorenewEnabled] = useState(
    checkoutPreview.autoRenew.status === web.public_.AutoRenew.Status.ENABLED
  );
  const id = useId();

  return (
    <div className={styles["review-autorenew-section"]}>
      <ContainerButton className={styles["toggle"]} data-cy="autorenew-toggle">
        <div className={`text:eyebrow-1 ${styles["toggle-label"]}`}>
          AUTO-RENEW
          <InfoTooltip
            className={styles["grey-info-tooltip"]}
            message={`Auto-renew can help you build payment history automatically by maintaining a balance on your ${getCreditAccountMentalModelName()}.`}
          />
        </div>
        <div className={`text:eyebrow-3 ${styles["state-label"]}`}>
          {autorenewEnabled ? "ON" : "OFF"}
        </div>
        <Switch
          checked={autorenewEnabled}
          id={id}
          onChange={() => {
            const enabled = !autorenewEnabled;
            track.tap("CA - Review Autorenew - Toggle Switch", {
              "autorenew enabled": enabled,
            });
            setAutorenewEnabled(enabled);

            const autoRenew = {
              status: enabled
                ? web.public_.AutoRenew.Status.ENABLED
                : web.public_.AutoRenew.Status.DISABLED,
            };
            const items = [{ product, quantity: 1 }];
            dispatch(updateBag({ autoRenew, items }));
          }}
        />
      </ContainerButton>
      <div className={`text:small ${styles["summary-p"]}`}>
        Auto-renew can help you build payment history automatically by
        maintaining a balance on your {getCreditAccountMentalModelName()}.
      </div>
      {autorenewEnabled && (
        <div className={`text:small ${styles["summary-p"]}`}>
          {productTitle} will auto-renew on {formattedAutorenewDate}. You can
          modify this through the Order Center.
        </div>
      )}
    </div>
  );
};

export default ReviewAutorenewSection;
